import {useState} from "react";
import http from "../../../shared/utils/http";
import {HourModel} from "../models/Hour.model";


export default function useCalendarChange(employees: any[] | undefined, hours: HourModel[], setHours: (data: HourModel[]) => void, resetContext: () => void) {
    const [selectedRange, setSelectedRange] = useState<any>(null);
    const handleEventDrop = (info: any) => {
        const employeeId = info.event.extendedProps.idEmployee
        const hourEmployee = hours.find(ele => ele.idEmployee === employeeId && ele.year === info.oldEvent.start.getFullYear() && ele.day === info.oldEvent.start.getDate() && ele.month === info.oldEvent.start.getMonth())
        http.post(`employees/${employeeId}/add`, {
            year: info.oldEvent.start.getFullYear(),
            month: info.oldEvent.start.getMonth(),
            day: info.oldEvent.start.getDate(),
            hours: (hourEmployee?.listUpdate || hourEmployee?.list)?.filter((h, index) => index !== info.oldEvent.extendedProps.index) || []
        }).then(res => {
            const updateHours = [...hours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour]
            const hourEmployeeNew = updateHours.find(ele => ele.idEmployee === employeeId && ele.year === info.event.start.getFullYear() && ele.day === info.event.start.getDate() && ele.month === info.event.start.getMonth())
            const isDifferentDay = info.event.start.getDate() !== info.event.end.getDate()
            const originalType = (hourEmployee?.listUpdate || hourEmployee?.list)?.[info.oldEvent.extendedProps.index]?.type ?? 'work';
            http.post(`employees/${employeeId}/add`, {
                year: info.event.start.getFullYear(),
                month: info.event.start.getMonth(),
                day: info.event.start.getDate(),
                hours: [
                    ...(hourEmployeeNew ? (hourEmployeeNew.listUpdate || hourEmployeeNew.list) : []),
                    {
                        type: originalType,
                        start: {
                            hour: info.event.start.getHours(),
                            minute: info.event.start.getMinutes(),
                        },
                        end: {
                            hour: isDifferentDay? 0 :info.event.end.getHours(),
                            minute: isDifferentDay? 0: info.event.end.getMinutes(),
                        }
                    }
                ]
            }).then(res => {
                setHours([...updateHours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour])
            })

        })
        // setEvents(events.map(ele => ele.id === info.event.id? info.event: ele))
        // Logica per aggiornare l'evento lato server
    };
    const deleteEvent = (event: any) => {

        const employeeId = event.extendedProps.idEmployee
        const hourEmployee = hours.find(ele => ele.idEmployee === employeeId && ele.year === event.start.getFullYear() && ele.day === event.start.getDate() && ele.month === event.start.getMonth())
        http.post(`employees/${employeeId}/add`, {
            year: event.start.getFullYear(),
            month: event.start.getMonth(),
            day: event.start.getDate(),
            hours: (hourEmployee?.listUpdate || hourEmployee?.list)?.filter((h, index) => index !== event.extendedProps.index) || []
        }).then(res => {
            const updateHours = [...hours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour]

            setHours([...updateHours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour])
            resetContext()

        })
        // setEvents(events.map(ele => ele.id === info.event.id? info.event: ele))
        // Logica per aggiornare l'evento lato server
    };

    const handleEventResize = (info: any) => {
        const employeeId = info.event.extendedProps.idEmployee
        const hourEmployee = hours.find(ele => ele.idEmployee === employeeId && ele.year === info.oldEvent.start.getFullYear() && ele.day === info.oldEvent.start.getDate() && ele.month === info.oldEvent.start.getMonth())
        const isDifferentDay = info.event.start.getDate() !== info.event.end.getDate()
        const originalType = (hourEmployee?.listUpdate || hourEmployee?.list)?.[info.oldEvent.extendedProps.index]?.type ?? 'work';
        http.post(`employees/${employeeId}/add`, {
            year: info.event.start.getFullYear(),
            month: info.event.start.getMonth(),
            day: info.event.start.getDate(),
            hours: [
                ...(hourEmployee ? (hourEmployee.listUpdate || hourEmployee.list)?.filter((h, index) => index !== info.oldEvent.extendedProps.index) : []),
                {
                    type: originalType,
                    start: {
                        hour: info.event.start.getHours(),
                        minute: info.event.start.getMinutes(),
                    },
                    end: {
                        hour: isDifferentDay? 0 : info.event.end.getHours(),
                        minute: isDifferentDay? 0 :info.event.end.getMinutes(),
                    }
                }
            ]
        }).then(res => {
            setHours([...hours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour])
        })
        // setEvents(events.map(ele => ele.id === info.event.id? info.event: ele))
        // Logica per aggiornare l'evento lato server
    };
    const handleEventReceive = (info: any) => {

        const userId = info.draggedEl.getAttribute('data-user-id');
        const employee = employees?.find((u) => u.idDocument === userId);

        if (employee) {
            info.event.setProp('backgroundColor', employee.color);
            const newEndDate = new Date(info.event.start);
            newEndDate.setHours(newEndDate.getHours() + 4);

            info.event.setEnd(newEndDate);
            const hourEmployee = hours.find(ele => ele.idEmployee === userId && ele.year === info.event.start.getFullYear() && ele.day === info.event.start.getDate() && ele.month === info.event.start.getMonth())
            const isDifferentDay = info.event.start.getDate() !== info.event.end.getDate()
            http.post(`employees/${userId}/add`, {
                year: info.event.start.getFullYear(),
                month: info.event.start.getMonth(),
                day: info.event.start.getDate(),
                hours: [
                    ...(hourEmployee ? (hourEmployee.listUpdate || hourEmployee.list) : []),
                    {
                        type: 'work',
                        start: {
                            hour: info.event.start.getHours(),
                            minute: info.event.start.getMinutes(),
                        },
                        end: {
                            hour: isDifferentDay? 0 : info.event.end.getHours(),
                            minute: isDifferentDay? 0 : info.event.end.getMinutes(),
                        }
                    }
                ]
            }).then(res => {
                setHours([...hours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour])
            })

        }
    };

    const changeEventData = (data: any, info: any) => {
        const employeeId = info.event.extendedProps.idEmployee
        const hourEmployee = hours.find(ele => ele.idEmployee === employeeId && ele.year === info.event.start.getFullYear() && ele.day === info.event.start.getDate() && ele.month === info.event.start.getMonth())
        const isDifferentDay = info.event.start.getDate() !== info.event.end.getDate()
        http.post(`employees/${employeeId}/add`, {
            year: info.event.start.getFullYear(),
            month: info.event.start.getMonth(),
            day: info.event.start.getDate(),
            hours: [
                ...(hourEmployee ? (hourEmployee.listUpdate || hourEmployee.list)?.filter((h, index) => index !== info.event.extendedProps.index) : []),
                {
                    type: data.name,
                    start: {
                        hour: info.event.start.getHours(),
                        minute: info.event.start.getMinutes(),
                    },
                    end: {
                        hour: isDifferentDay? 0 : info.event.end.getHours(),
                        minute: isDifferentDay? 0 : info.event.end.getMinutes(),
                    }
                }
            ]
        }).then(res => {
            setHours([...hours.filter(ele => ele.idDocument !== res.hour.idDocument), res.hour])
            resetContext()
        })
    }
    return {
        selectedRange,
        setSelectedRange,
        handleEventResize,
        deleteEvent,
        handleEventDrop,
        handleEventReceive,
        changeEventData
    };
}
